@import '~style-sheet-helpers/core.less';
@import '../../app-brand/entities/entity-layer.module.less';

.mappings-collapsible-list {
  border: none;
}

.map-order-import-table {
  border: 1px solid @order-import-column-mapper--table--border-color;
  border-bottom: none;
  min-height: auto;
}

.map-order-import-table-head {
  display: flex;
  justify-content: flex-start;
  align-items: center;
  height: 35px;
  margin: 0;
  width: 100%;
  background-color: @order-import-column-mapper--table-header--background-color;
  padding: 0 15px;
  font-weight: 100;
  color: @order-import-column-mapper--table-header--text-color;
  font-size: 14px;
}

.table-head-first-column {
  width: 45%;
}

.map-order-import-table-content {
  display: flex;
  justify-content: flex-start;
  height: 45px;
  margin: 0;
  width: 100%;
  padding: 0 15px;
  font-size: 0.95em;
  border-bottom: 1px solid @order-import-column-mapper--table-content--border-color;
}

.table-content-first-column {
  width: 45%;
}

.mappings-dropdown-wrapper {
  width: 55%;
}

.inner-text-lighter {
  color: @order-import-column-mapper--inner-text-lighter--border-color;
}

.mapping-dropdown-wrapper {
  width: 100%;
  padding-top: 8px;
}
